/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { useContent } from '../../context/ContentContext';

const Footer = () => {
  const { content } = useContent();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" />
        </svg>
      </div>
      
      <div className="footer__main">
        <div className="footer__container">
          <div className="footer__section">
            <div className="footer__logo">
              <img src="/assets/img/logo2.png" alt="FARMO" />
              <h3>FARMO</h3>
            </div>
            <p className="footer__tagline">
              Empowering communities, protecting the future.
            </p>
            <p className="footer__description">
              Building food security, climate resilience, and lasting prosperity for South Sudanese communities.
            </p>
            <div className="footer__social">
              <a href="https://facebook.com/farmosouthsudan" target="_blank" rel="noopener noreferrer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://twitter.com/farmosouthsudan" target="_blank" rel="noopener noreferrer">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="https://linkedin.com/company/farmo" target="_blank" rel="noopener noreferrer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="https://instagram.com/farmosouthsudan" target="_blank" rel="noopener noreferrer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://youtube.com/farmosouthsudan" target="_blank" rel="noopener noreferrer">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>

          <div className="footer__section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/programs">Our Programs</Link></li>
              <li><Link to="/news">Success Stories</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4>Our Programs</h4>
            <ul>
              <li><Link to="/programs">Food Security</Link></li>
              <li><Link to="/programs#health">Health & Nutrition</Link></li>
              <li><Link to="/programs#education">Education & Research</Link></li>
              <li><Link to="/programs#peace">Peacebuilding</Link></li>
              <li><Link to="/programs#environment">Environment</Link></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4>Get In Touch</h4>
            <ul className="footer__contact">
              <li>
                <i className="ri-map-pin-line"></i>
                <span>{content.contact.address}</span>
              </li>
              <li>
                <i className="ri-phone-line"></i>
                <a href={`tel:${content.contact.phone}`}>{content.contact.phone}</a>
              </li>
              <li>
                <i className="ri-mail-line"></i>
                <a href={`mailto:${content.contact.email}`}>{content.contact.email}</a>
              </li>
              <li>
                <i className="ri-time-line"></i>
                <span>Mon-Fri: {content.contact.hours.weekday}</span>
                <span>Sat: {content.contact.hours.saturday}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-container">
          <p>&copy; {currentYear} FARMO. All rights reserved.</p>
          <p><a href="https://junubai.com" style={{color: 'wheat'}}>Developed by. GraBit Technologies</a></p>
          <div className="footer__bottom-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Use</a>
            <a href="/psea">PSEA Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;